<div style="padding:7px">
    <h5>Confirmation Result</h5>
    <div>
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">PO Number</th>
            <th scope="col">Item Number</th>
            <th scope="col">Remark</th>
            <th scope="col">Upload</th>
            <th scope="col">Message Type</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let element of responseData">
            <td>{{ element.EBELN }}</td>
            <td>{{ element.EBELP }}</td>
            <td>{{ element.REMARK }}</td>
            <td>{{ element.UPLOAD }}</td>
            <td> 
              <span *ngIf="element.MSGTY === 'E'">Error</span>
              <!-- <span *ngIf="element.MSGTY === 'I'">Information</span> -->
              <!-- <span *ngIf="element.MSGTY === 'W'">Warning</span> -->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div>
      <button type="button" class="btn btn-primary mb-2" style="float:right" (click)="onModalClose()">Close</button>
    </div>
</div>